export function generateFakeEmail(): string {
  const suffix = (Date.now() % 10_000_000).toString().padStart(7, '0')
  return `emu-gen-${suffix}@milva-test.io`
}
